export default {
  authPage: {
    backHome: "Back to home",
    tabLogin: "Sign in",
    tabRegister: "Register",
    welcomeTitle: "Welcome",
    welcomeSubtitle: "Sign in to your portal account",
    sessionExpiredNotice: "Your session has expired or is invalid. Please sign in again.",
    password: "Password",
    forgotPassword: "Forgot password?",
    passwordPlaceholder: "Enter password",
    loginSubmit: "Sign in",
    loggingIn: "Signing in...",
    esiaLogin: "Sign in with Gosuslugi",
    esiaDevNotice: "Gosuslugi sign-in is under development and will be available soon.",
    forgotPasswordModalTitle: "Reset password",
    forgotPasswordModalHint: "Enter your email and we will send a reset link.",
    forgotPasswordSubmit: "Send link",
    forgotPasswordSending: "Sending...",
    forgotPasswordSuccess: "If that email is registered, we sent instructions.",
    forgotPasswordClose: "Close",
    resetPasswordTitle: "New password",
    resetPasswordSubtitle: "Choose a new password for your account.",
    resetPasswordSubmit: "Save password",
    resetPasswordSaving: "Saving...",
    resetPasswordSuccessTitle: "Password updated",
    resetPasswordSuccessHint: "You can now sign in with your new password.",
    resetPasswordGoLogin: "Go to sign in",
    resetLinkInvalidTitle: "Invalid link",
    resetLinkInvalidHint:
      "The reset link is incomplete or broken. Request a new reset email from the sign-in page.",
    confirmEmailCheckingTitle: "Confirming your email",
    confirmEmailCheckingHint: "Please wait a few seconds.",
    confirmEmailSuccessTitle: "Email confirmed",
    confirmEmailSuccessHint: "You can now sign in to your account.",
    confirmEmailAutoRedirectHint: "You will be redirected to sign in in a few seconds.",
    confirmEmailErrorTitle: "Could not confirm email",
    confirmEmailGoLogin: "Go to sign in",
    confirmLinkInvalidTitle: "Invalid confirmation link",
    confirmLinkInvalidHint:
      "The confirmation link is incomplete or broken. Request a new confirmation email from the sign-in page.",
    noAccount: "No account?",
    signUpLink: "Create one",
    createTitle: "Create an account",
    createSubtitle: "Join the Leninka portal",
    lastName: "Last name",
    firstName: "First name",
    middleName: "Middle name",
    email: "E-mail",
    passwordMin: "At least 8 characters",
    repeatPassword: "Repeat password",
    consent: {
      prefixTerms: "I accept the",
      linkTerms: "user agreement",
      prefixPersonal: "I consent to the",
      linkPersonal: "processing of my personal data",
      prefixPrivacy: "I have read the",
      linkPrivacy: "personal data processing policy",
    },
    captchaMissingHint:
      "Registration requires Yandex SmartCaptcha: set VITE_YANDEX_SMARTCAPTCHA_SITEKEY in your .env file (see .env.example).",
    createSubmit: "Create account",
    registering: "Creating account...",
    hasAccount: "Already have an account?",
    loginLink: "Sign in",
    successTitle: "Account created!",
    successHint: "Your account is ready — you can sign in with",
    enterAccount: "Sign in",
    footerNote: "Leninka IP \u00a9 2026",
    errors: {
      fillAll: "Please fill in all fields.",
      fillRequired: "Please fill in all required fields.",
      passwordShort: "Password must be at least 8 characters.",
      passwordMismatch: "Passwords do not match.",
      agreeTerms: "You must accept the user agreement.",
      agreePersonalData: "You must consent to the processing of personal data.",
      agreePrivacyPolicy: "You must accept the personal data processing policy.",
      captchaRequired: "Please complete the SmartCaptcha verification.",
      captchaConfig: "Captcha is not configured. Contact the administrator or set the key in .env.",
      loginFailed: "Sign-in failed. Check your email and password.",
      emailNotConfirmed: "Email is not confirmed yet. Confirm it using the link from your email and try again.",
      registerFailed: "Registration failed. Try again later or check your details.",
      resetFailed: "Could not reset the password. The link may have expired.",
      forgotSendFailed: "Could not send the email. Try again later.",
      confirmFailed: "Could not confirm the email. The link may be expired or already used.",
    },
  },
}
